<button
  #optionElement
  (click)="onClick()"
  [attr.tabindex]="-1"
  [disabled]="disabled()"
  [ngClass]="{
    'select-option--selected': selected(),
    'select-option--focused': focused(),
  }"
  class="select-option"
  type="button"
>
  <ng-container
    [ngTemplateOutlet]="optionTemplate() || defaultOptionTemplate"
    [ngTemplateOutletContext]="{ $implicit: option() }"
  />
</button>

<ng-template #defaultOptionTemplate let-option>
  @for (fragment of labelFragments; track $index; let odd = $odd) {
    <ng-container>
      @if (odd) {
        <span class="select-option__highlighted-text">
          {{ fragment }}
        </span>
      } @else {
        <span>{{ fragment }}</span>
      }
    </ng-container>
  }
  @if (optionSubLabel() && optionSubLabel()?.length) {
    <span class="select-option__sub-label">
      {{ optionSubLabel() }}
    </span>
  }
</ng-template>
